module.exports = __webpack_public_path__ + "media/images/carlyle-c7ef5b94.png";